import { useQuery } from '@tanstack/react-query';
import { fetchCircuits } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCircuits = ({
  pageNumber = 1,
  pageSize = 20,
}: { pageNumber?: number; pageSize?: number } = {}) =>
  useQuery({
    queryFn: async () => {
      const data = await extractData(
        fetchCircuits({ query: { PageNumber: pageNumber, PageSize: pageSize } })
      );
      return data;
    },
    queryKey: ['circuits', pageNumber, pageSize],
  });
